import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share-a11y--sprite",
  "use": "share-a11y--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"share-a11y--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.53 3.47L12 2.94l-.53.53-4 4 1.06 1.061 2.72-2.72v8.19h1.5V5.81l2.72 2.72 1.061-1.061-4-4zM4.25 13v6.75h15.5V13h-1.5v5.25H5.75V13h-1.5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol